import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: "Services", href: "#services" },
    { name: "Why Choose Us", href: "#why-us" },
    { name: "Security", href: "#security" },
    { name: "Closing Options", href: "#closing-options" },
    { name: "FAQ", href: "#faq" },
    { name: "Contact", href: "#contact" },
  ];

  const serviceAreas = [
    "Pennsylvania",
    "New Jersey",
    "New York",
    "Florida",
  ];

  return (
    <footer className="bg-[#0F172A] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <div className="flex flex-col">
                <span className="font-serif text-2xl font-semibold text-white">
                  American Legal Abstract
                </span>
                <span className="text-xs tracking-widest uppercase text-white/50 mt-1">
                  Title Insurance Agency
                </span>
              </div>
            </div>
            <p className="text-white/60 leading-relaxed mb-6 max-w-md">
              For over 30 years, we've provided attorney-led title insurance services 
              across Pennsylvania, New Jersey, New York, and Florida. Our commitment 
              to excellence ensures every closing reflects well on you.
            </p>
            <div className="flex items-center gap-6">
              <img
                src="https://customer-assets.emergentagent.com/job_closing-pros/artifacts/dphzwrxi_First%20American%20Logo.jpg"
                alt="First American"
                className="h-10 w-auto rounded opacity-80 hover:opacity-100 transition-opacity"
              />
              <img
                src="https://customer-assets.emergentagent.com/job_closing-pros/artifacts/1yvypi3w_Fidelity%20Logo.jpg"
                alt="Fidelity National"
                className="h-10 w-auto opacity-80 hover:opacity-100 transition-opacity"
              />
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-[#B45309] mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-white text-sm btn-transition"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-[#B45309] mb-6">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#B45309] mt-0.5" strokeWidth={1.5} />
                <a href="tel:8003057119" className="text-white/60 text-sm hover:text-white btn-transition">(800) 305-7119</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#B45309] mt-0.5" strokeWidth={1.5} />
                <a href="mailto:info@alegaltitle.com" className="text-white/60 text-sm hover:text-white btn-transition">info@alegaltitle.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#B45309] mt-0.5" strokeWidth={1.5} />
                <div className="text-white/60 text-sm">
                  2337 Philmont Avenue, Suite 205<br />
                  Huntingdon Valley, PA 19006
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#B45309] mt-0.5" strokeWidth={1.5} />
                <div className="text-white/60 text-sm">
                  {serviceAreas.map((area, index) => (
                    <span key={area}>
                      {area}{index < serviceAreas.length - 1 ? " • " : ""}
                    </span>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {currentYear} American Legal Abstract. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/40 hover:text-white text-sm btn-transition">
              Privacy Policy
            </a>
            <a href="#" className="text-white/40 hover:text-white text-sm btn-transition">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
